import { type RuleBoxLabels, ruleBoxLabels } from "@loot-os/api-contract/shopifyRuleBoxForm";
import { useQuery } from "@tanstack/react-query";

import { useTRPC } from "./trpc";

/**
 * The names a rule description gives the collections, locations and category values a rule holds,
 * from the builder's cached choices; null until they load, when descriptions count them instead.
 */
export function useRuleLabels(): RuleBoxLabels | null {
  const trpc = useTRPC();
  const facets = useQuery(trpc.catalog.facets.queryOptions());
  return facets.data ? ruleBoxLabels(facets.data) : null;
}
